import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'

const heading = (fundName, href) => {
  const headlineColor = href ? 'u-textColorBrandLight' : 'u-textColorBrand'
  return (
    <div className="fund-title u-marginBottom1gu">
      <h3
        className={`${headlineColor} u-textBold`}
        data-analytics="fund-card-feature-fund-title"
      >
        {fundName}
      </h3>
    </div>
  )
}

const subHeading = (ticker, category) => {
  return (
    <p className="u-fontFamilyCondensed u-textColorNeutral75 u-marginBottom2gu u-textSizeMsrm1">
      <span className="u-textBold">{ticker}</span>
      <span className="u-marginLeft1gu u-marginRight1gu u-textColorNeutral25">
        |
      </span>
      <span>{category}</span>
    </p>
  )
}

const bodyText = (content) => {
  return <p className="u-textColorGrayDark">{content}</p>
}

const starRating = (rating) => {
  const solidStars = parseInt(rating)
  const elements = []
  for (let index = 1; index <= 5; index++) {
    const starType = index <= solidStars ? 'star' : 'star_outline'
    elements.push(
      <span
        className="Icon--material u-marginRight1gu u-textSizeMsrp1"
        key={index}
      >
        {starType}
      </span>
    )
  }
  return elements
}

const CardContent = forwardRef(function CardContent(
  { rating, fundName, href, ticker, category, body, minHeight },
  ref
) {
  return (
    <div>
      <div className="Card-body" ref={ref} style={{ minHeight: minHeight }}>
        {rating ? <div className="starRating">{starRating(rating)}</div> : null}
        {fundName ? heading(fundName, href) : null}
        {ticker && category ? subHeading(ticker, category) : null}
        {body ? bodyText(body) : null}
      </div>
    </div>
  )
})

CardContent.propTypes = {
  rating: PropTypes.string,
  fundName: PropTypes.string,
  href: PropTypes.string,
  ticker: PropTypes.string,
  category: PropTypes.string,
  body: PropTypes.string,
  minHeight: PropTypes.number,
}

export { heading, subHeading, bodyText, starRating, CardContent }
